import i18n from '@/plugins/i18n';
import { KAFKA_OVERVIEW_TAB_KEY } from '@/utils/templates/mqTemplate/mq.constants';

const kafkaOverviewMultiGraphs = () => ({
  [KAFKA_OVERVIEW_TAB_KEY.BROKER]: [
    {
      metricName: 'kafka_broker_bytes_in_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.bytesIn'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_bytes_out_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.bytesOut'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_total_produce_requests_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.totalProducedRequestRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_total_fetch_requests_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.totalFetchRequestrate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_messages_in_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.messagesIn'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_leader_election_rate_and_timems',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.leaderElectionRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_broker_unclean_leader_elections_per_sec',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.broker'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.uncleanedElectionLeaderPerSec'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
  ],
  [KAFKA_OVERVIEW_TAB_KEY.PRODUCER]: [
    {
      metricName: 'kafka_producer_request_rate',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.producer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.requestRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_producer_response_rate',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.producer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.responseRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_producer_record_error_rate',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.producer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.errorRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_producer_request_latency_avg',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.producer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.requestAvgLatency'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.value-ms'),
      },
    },
  ],
  [KAFKA_OVERVIEW_TAB_KEY.CONSUMER]: [
    {
      metricName: 'kafka_consumer_fetch_size_avg',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.consumer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.avgFetchSize'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_consumer_response_rate',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.consumer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.responseRate'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_consumer_records_lag',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.consumer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.consumerLag'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
    {
      metricName: 'kafka_consumer_records_consumed_rate',
      valueColumn: 'value',
      headers: [
        {
          label: i18n.global.t('mq.consumer'),
          width: '60%',
          key: 'label',
          sortable: true,
          dataType: 'string',
        },
        {
          label: i18n.global.t('mq.avg'),
          width: '20%',
          key: 'avg',
          sortable: true,
          dataType: 'number',
        },
        {
          label: i18n.global.t('mq.max'),
          width: '20%',
          key: 'max',
          sortable: true,
          dataType: 'number',
        },
      ],
      isMultiMetric: false,
      formula: (value) => value.toFixed(3),
      title: i18n.global.t('mq.messageConsumed'),
      graphTitles: {
        x: i18n.global.t('time'),
        y: i18n.global.t('mq.rate'),
      },
    },
  ],
});

const kafkaOverviewSingleGraphs = () => ({
  [KAFKA_OVERVIEW_TAB_KEY.BROKER]: [
    {
      width: '49%',
      title: i18n.global.t('mq.noOfBrokers'),
      header: {
        title: i18n.global.t('mq.noOfBrokers'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'kafka_active_broker_count_service',
      queryMetricType: 'readAndAggregateMetricsFilteredAtServiceScope',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('mq.time'),
        y: i18n.global.t('mq.count'),
      },
      labels: {
        xAxis: i18n.global.t('mq.time'),
        yAxis: i18n.global.t('mq.count'),
      },
    },
  ],
  [KAFKA_OVERVIEW_TAB_KEY.PRODUCER]: [
    {
      width: '49%',
      title: i18n.global.t('mq.noOfProducers'),
      header: {
        title: i18n.global.t('mq.noOfProducers'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'kafka_producer_count_service',
      queryMetricType: 'readAndAggregateMetricsFilteredAtServiceScope',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('mq.time'),
        y: i18n.global.t('mq.count'),
      },
      labels: {
        xAxis: i18n.global.t('mq.time'),
        yAxis: i18n.global.t('mq.count'),
      },
    },
  ],
  [KAFKA_OVERVIEW_TAB_KEY.CONSUMER]: [
    {
      width: '49%',
      title: i18n.global.t('mq.noOfConsumers'),
      header: {
        title: i18n.global.t('mq.noOfConsumers'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'kafka_consumer_count_service',
      queryMetricType: 'readAndAggregateMetricsFilteredAtServiceScope',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('mq.time'),
        y: i18n.global.t('mq.count'),
      },
      labels: {
        xAxis: i18n.global.t('mq.time'),
        yAxis: i18n.global.t('mq.count'),
      },
    },
  ],
});
export { kafkaOverviewMultiGraphs, kafkaOverviewSingleGraphs };
